import { getRequest } from '@/utils/http'

export async function getStsConfig (params) {
  return await getRequest('/oss-sts', { params }, { apiPrefix: '/backend' })
}

export async function getOssUploadConfig () {
  return await getRequest('/common/oss-upload-config')
}
